import React from "react";
import { Block, Row, Col, Button, Icon } from "framework7-react";
import { setLiteral } from "../../../js/helpers";

const UserInfo = ({ userData, lsLiterales }) => {
  return (
    <Col width="100">
      <Row>
        <Col width="25">
          <Block />
        </Col>
        <Col className="center" width="50">
          <Block className="center">
            <div id="txtUserName" className="ussername bold">
              {userData.firstName +
                " " +
                userData.lastName +
                " " +
                userData.secondLastName}
              <br />
              <div id="email" className="light">
                {userData.email}
              </div>
            </div>
          </Block>
        </Col>
        <Col width="25">
          <Block />
        </Col>
      </Row>
      <Block />
      {/* <Row>
                <Col width='25'><br /></Col>
                <Col width='25' className='center'><Icon f7='person_crop_rectangle' size='15px'></Icon><a className='light'>{' '}CURP</a></Col>
                <Col width='50' className='left'>{': ' + userData.identificationUnique}</Col>
            </Row> */}
      <Block />
      <Row>
        <Col width="50" className="right">
          <Icon f7="person" size="15px"></Icon>
          <a className="light"> IDENTIFICACIÓN</a>
        </Col>
        <Col width="50" className="left">
          {":" + " " + userData.identificationData}
        </Col>
      </Row>
      <Block />
      <Row>
        <Col width="50" className="right">
          <Icon f7="calendar_today" size="15px"></Icon>
          <a className="light"> {setLiteral(lsLiterales, 102008)}</a>
        </Col>
        <Col width="50" className="left">
          {": " + userData.birthDate}
        </Col>
      </Row>
      <Block />
      <Row>
        <Col width="50" className="right">
          <Icon f7="phone" size="15px"></Icon>
          <a className="light"> {setLiteral(lsLiterales, 101019)}</a>
        </Col>
        <Col width="50" className="left">
          {": " + userData.personalPhone}
        </Col>
      </Row>
      <Block />
      <Row>
        <Col width="100" id="adress">
          <Row>
            <Col width="100" className="light oblique center">
              Domicilio
            </Col>
          </Row>

          <Row>
            <Col width="100" className="center light">
              {userData.typeAddress}
              <a>{" " + " " + userData.address}</a>
              <p>
                {userData.city +
                  "," +
                  " " +
                  userData.district +
                  " " +
                  userData.province}
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
    </Col>
  );
};
export default UserInfo;
